import { render, staticRenderFns } from "./ClasesDetalleNotas.vue?vue&type=template&id=b28b6d66&"
import script from "./ClasesDetalleNotas.vue?vue&type=script&lang=js&"
export * from "./ClasesDetalleNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports